import getTotalLength from './getTotalLength.js';
const verge = require('verge');
const $iconAnimate = $('.icon-animate');

if ($iconAnimate.length) {
	function initAnimation() {
		$iconAnimate.each(function() {
			if (verge.inViewport(this)) {
				$(this)
					.find('.js-stroke-animation')
					.velocity({
						strokeDashoffset: 0
					}, {
						duration: 1000,
						delay: 400,
						mobileHA: false,
						begin: (items) => $(items).css('opacity', 1)
					});
			}
		})
	};

	function setStartStyles(path) {
		const length = getTotalLength(path);
		path.style.strokeDashoffset = length;
		path.style.strokeDasharray = length;
	}

	$iconAnimate.each((i, svg) => {
		const $svg = $(svg);
		const $animationItems = $svg.find('.js-stroke-animation');

		$animationItems.each((i, path) => setStartStyles(path))
	})

	initAnimation();
	$(window).on('scroll resize load', initAnimation);
}



// WEBPACK FOOTER //
// ./frontend/components/animation/animation.js